/// <reference types="./organization.d.mts" />
import * as $style_guideline from "../../../common/data/style_guideline.mjs";
import * as $console from "../../../common_common/gleam/javascript/console.mjs";
import * as $list_ from "../../../common_common/gleam/list/extra.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $effect from "../../../lustre/lustre/effect.mjs";
import * as $state from "../../data/model/state.mjs";
import { State } from "../../data/model/state.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $organization from "../../data/organization.mjs";
import * as $route from "../../data/route.mjs";
import * as $loading from "../../data/ui/loading.mjs";
import * as $organization_effects from "../../frontend/effects/organization.mjs";
import { Ok, toList, makeError } from "../../gleam.mjs";

const FILEPATH = "src/frontend/update/organization.gleam";

export function update(state, msg) {
  if (msg instanceof $msg.ApiSentUserFunctionUpdated) {
    let user_id = msg[0];
    let function$ = msg[2];
    let _pipe = $organization.update_user(
      state.organization,
      user_id,
      function$,
    );
    let _pipe$1 = ((_capture) => {
      return $state.set_organization(state, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedUsers) {
    let users = msg[0];
    let _block;
    let _record = state.organization;
    _block = new $organization.Organization(
      _record.tags,
      users,
      _record.style_guidelines,
      _record.new_style_guideline,
    );
    let _pipe = _block;
    let _pipe$1 = ((_capture) => {
      return $state.set_organization(state, _capture);
    })(_pipe);
    let _pipe$2 = $state.mark_as_loaded(_pipe$1, $loading.users);
    let _pipe$3 = $state.empty_proposal_builder(_pipe$2);
    return $pair.new$(_pipe$3, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedTags) {
    let tags = msg.tags;
    let _block;
    let _record = state.organization;
    _block = new $organization.Organization(
      tags,
      _record.users,
      _record.style_guidelines,
      _record.new_style_guideline,
    );
    let _pipe = _block;
    let _pipe$1 = ((_capture) => {
      return $state.set_organization(state, _capture);
    })(_pipe);
    let _pipe$2 = $state.mark_as_loaded(_pipe$1, $loading.organization_tags);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedStyleGuideline) {
    let style_guideline = msg.style_guideline;
    let _block;
    let _pipe = state.organization.style_guidelines;
    let _pipe$1 = $list.filter(
      _pipe,
      (s) => { return s.id !== style_guideline.id; },
    );
    _block = $list_.insert(_pipe$1, style_guideline);
    let style_guidelines = _block;
    let _block$1;
    let _record = state.organization;
    _block$1 = new $organization.Organization(
      _record.tags,
      _record.users,
      style_guidelines,
      _record.new_style_guideline,
    );
    let _pipe$2 = _block$1;
    let _pipe$3 = ((_capture) => {
      return $state.set_organization(state, _capture);
    })(_pipe$2);
    return $pair.new$(_pipe$3, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedStyleGuidelines) {
    let style_guidelines = msg.style_guidelines;
    let _block;
    let _record = state.organization;
    _block = new $organization.Organization(
      _record.tags,
      _record.users,
      style_guidelines,
      _record.new_style_guideline,
    );
    let _pipe = _block;
    let _pipe$1 = ((_capture) => {
      return $state.set_organization(state, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedQualificationMatrix) {
    let qm = msg.qm;
    return [
      (() => {
        let _record = state;
        return new State(
          _record.window_dimensions,
          _record.access_token,
          _record.analytics,
          _record.client,
          _record.collapsed_navbar,
          _record.comments,
          _record.comments_draft_mentions,
          _record.comments_in_edition,
          _record.connectors,
          _record.content_library,
          _record.copilot,
          _record.custom_rewording_input,
          _record.draft_comments,
          _record.dropdown_unsubscriber,
          _record.feed_opened,
          _record.language,
          _record.loading,
          _record.modal,
          _record.modal_unsubscriber,
          _record.notifications,
          _record.notifications_unread,
          _record.opened_projects,
          _record.organization,
          _record.permissions,
          _record.projects,
          _record.proposal_builder,
          _record.proposals,
          qm,
          _record.route,
          _record.running_requests,
          _record.translations,
          _record.user,
          _record.sources_tooltip,
          _record.sources_tooltip_unsubscriber,
          _record.maintenance,
        );
      })(),
      $effect.none(),
    ];
  } else if (msg instanceof $msg.UserClickedOnAddStyleGuideline) {
    let _pipe = state;
    return $pair.new$(
      _pipe,
      $route.push(new $route.Organization(new $route.NewStyleGuideline())),
    );
  } else if (msg instanceof $msg.UserClickedOnStyleGuideline) {
    let id = msg.id;
    let _block;
    let _pipe = state.organization.style_guidelines;
    _block = $list.find(_pipe, (s) => { return s.id === id; });
    let style_guideline = _block;
    if (!(style_guideline instanceof Ok)) {
      throw makeError(
        "let_assert",
        FILEPATH,
        "frontend/update/organization",
        107,
        "update",
        "Pattern match failed, no pattern matched the value.",
        {
          value: style_guideline,
          start: 3574,
          end: 3622,
          pattern_start: 3585,
          pattern_end: 3604
        }
      )
    }
    let style_guideline$1 = style_guideline[0];
    let _pipe$1 = new $style_guideline.NewStyleGuideline(
      new $option.Some(id),
      style_guideline$1.name,
      style_guideline$1.content,
    );
    let _pipe$2 = ((_capture) => {
      return $organization.set_new_style_guideline(state.organization, _capture);
    })(_pipe$1);
    let _pipe$3 = ((_capture) => {
      return $state.set_organization(state, _capture);
    })(_pipe$2);
    return $pair.new$(
      _pipe$3,
      $route.push(new $route.Organization(new $route.StyleGuidelineEdit(id))),
    );
  } else if (msg instanceof $msg.UserDeletedStyleGuideline) {
    let id = msg.id;
    let _pipe = $organization.remove_style_guideline(state.organization, id);
    let _pipe$1 = ((_capture) => {
      return $state.set_organization(state, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $organization_effects.delete_style_guideline(id));
  } else if (msg instanceof $msg.UserSelectedFunction) {
    let user_id = msg.user_id;
    let function$ = msg.function;
    let _pipe = $organization.update_user(
      state.organization,
      user_id,
      function$,
    );
    let _pipe$1 = ((_capture) => {
      return $state.set_organization(state, _capture);
    })(_pipe);
    return $pair.new$(
      _pipe$1,
      $organization_effects.update_user_function(state, user_id, function$),
    );
  } else if (msg instanceof $msg.UserSubmittedNewStyleGuideline) {
    let _pipe = $style_guideline.new_style_guideline();
    let _pipe$1 = ((_capture) => {
      return $organization.set_new_style_guideline(state.organization, _capture);
    })(_pipe);
    let _pipe$2 = ((_capture) => {
      return $state.set_organization(state, _capture);
    })(_pipe$1);
    return $pair.new$(
      _pipe$2,
      $effect.batch(
        toList([
          $organization_effects.upsert_style_guideline(state),
          $route.push(new $route.Organization(new $route.StyleGuidelines())),
        ]),
      ),
    );
  } else if (msg instanceof $msg.UserUpdatedNewStyleGuidelineName) {
    let name = msg.name;
    let _block;
    let _record = state.organization.new_style_guideline;
    _block = new $style_guideline.NewStyleGuideline(
      _record.id,
      name,
      _record.content,
    );
    let _pipe = _block;
    let _pipe$1 = ((_capture) => {
      return $organization.set_new_style_guideline(state.organization, _capture);
    })(_pipe);
    let _pipe$2 = ((_capture) => {
      return $state.set_organization(state, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else {
    let content = msg.content;
    let _block;
    let _record = state.organization.new_style_guideline;
    _block = new $style_guideline.NewStyleGuideline(
      _record.id,
      _record.name,
      content,
    );
    let _pipe = _block;
    let _pipe$1 = ((_capture) => {
      return $organization.set_new_style_guideline(state.organization, _capture);
    })(_pipe);
    let _pipe$2 = ((_capture) => {
      return $state.set_organization(state, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  }
}
